import { useEffect, useState, useCallback, FC } from 'react';
import { useSelector } from 'react-redux';
import { Form } from './Form';
import { currentSubmissionDataSelector } from '@selectors/submission';
import { LangEnum } from '@enums';

interface FormContainerProps {
  onChange: (...args) => void;
  lang: LangEnum;
}

const FormContainer: FC<FormContainerProps> = ({ onChange, lang }) => {
  const [form, setForm] = useState({});
  const submissionData = useSelector(currentSubmissionDataSelector);

  useEffect(() => {
    setForm(submissionData);
  }, [onChange, submissionData]);

  const handleFieldChange = useCallback(
    (key) => (value) => {
      const newForm = form;
      if (!value) {
        delete newForm[key];
      } else {
        newForm[key] = value;
      }
      setForm({ ...newForm });
      onChange(newForm);
    },
    [form, onChange]
  );

  return <Form form={form} handleFieldChange={handleFieldChange} lang={lang} />;
};

export { FormContainer };
